/**
 * Hideable client-table columns (column show/hide).
 *
 * Single source of truth for which client-table columns the user can toggle. The
 * `id`s MUST match the `isHidden(id)` gates + hide buttons in ClientTableView. The
 * Client (name) and Actions columns are intentionally PINNED — not listed here, so
 * they can never be hidden. Shared show/hide primitives live in
 * ../shared/columnVisibility.
 */
import type { HideableColumn } from "../shared/columnVisibility";

export const CLIENT_HIDEABLE_COLUMNS: HideableColumn[] = [
  { id: "industry", label: "Industry" },
  { id: "brand", label: "Brand" },
  { id: "integrations", label: "Integrations" },
  { id: "tags", label: "Tags" },
  { id: "created", label: "Created" },
  { id: "updated", label: "Updated" },
];
